import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
import qs from "qs";
import { intToChinese } from "@/static/js/utils";

const vuexLocal = new VuexPersistence({
  storage: window.sessionStorage,
});

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    projectName: null,

    token: null,

    duty: null,
  },

  getters: {
    isUserInRole: (state) => (rolename) => {
      if (!state.token?.roles || !Array.isArray(state.token?.roles))
        return false;

      if (Array.isArray(rolename)) {
        return state.token.roles.some((role) => rolename.includes(role));
      } else {
        return state.token.roles.includes(rolename);
      }
    },

    isAdmin: (state, getters) => {
      return getters.isUserInRole("ROLE_ADMIN");
    },

    currentTermYear: () => {
      let now = new Date();
      if (now.getMonth() > 8) return now.getFullYear();
      return now.getFullYear() - 1;
    },

    gradeYearOptions: () => {
      let options = [];
      const currentYear = new Date().getFullYear();
      for (let i = 2019; i <= currentYear; i++) {
        options.push(i);
      }
      if (new Date().getMonth() >= 8) options.push(currentYear);
      return options.reverse();
    },

    termYearMonthes() {
      let monthes = [];

      for (let i = 0; i < 12; i++) {
        let n = i + 9;
        if (n > 12) n -= 12;
        monthes.push(n);
      }

      return monthes;
    },

    formatClazzName: (state) => (clazz) => {
      return `${clazz.year}级${parseInt(clazz.name).toLocaleString(undefined, {
        minimumIntegerDigits: 2,
        useGrouping: false,
      })}班`;
    },

    formatFraction:
      (state) =>
      (num, maximumFractionDigits = 2, minimumFractionDigits) => {
        if (typeof num != "number" && !num) return "";
        return num.toLocaleString(undefined, {
          maximumFractionDigits,
          minimumFractionDigits,
          useGrouping: false,
        });
      },

    formatPercent:
      (state) =>
      (num, maximumFractionDigits = 2, minimumFractionDigits = 2) => {
        if (isNaN(num)) return "";
        if (!num && typeof num !== "number") return "";
        return num.toLocaleString(undefined, {
          style: "percent",
          maximumFractionDigits: maximumFractionDigits,
          minimumFractionDigits: minimumFractionDigits,
        });
      },

    screenHeight: () => {
      let height = window.innerHeight;
      return height;
    },

    intToChinese: () => (intValue) => {
      return intToChinese(intValue);
    },

    sortNumberArray: () => (numArray) => {
      if (!Array.isArray(numArray)) {
        throw new Error("非数组");
      }

      return numArray.sort((n1, n2) => {
        if (typeof n1 !== "number" && typeof n2 !== "number") return 0;
        else if (typeof n2 !== "number") return 1;
        else if (typeof n1 !== "number") return -1;

        if (n1 < n2) return -1;
        else if (n1 > n2) return 1;
        else return 0;
      });
    },

    sortNumber: () => (n1, n2) => {
      if (typeof n1 !== "number" && typeof n2 !== "number") return 0;
      else if (typeof n2 !== "number") return 1;
      else if (typeof n1 !== "number") return -1;

      if (n1 < n2) return -1;
      else if (n1 > n2) return 1;
      else return 0;
    },
  },

  mutations: {
    setProjectName(state, projectName) {
      state.projectName = projectName;
    },

    setToken(state, token) {
      state.token = token;
    },

    setDuty(state, duty) {
      state.duty = duty;
    },

    clearDuty(state) {
      state.duty = null;
    },

    afterLogin(state) {
      state.token = JSON.parse(window.localStorage.getItem("token"));
    },
  },

  actions: {
    getProjectName: async function ({ commit, state }) {
      return await new Promise((resolve, reject) => {
        Vue.axios
          .get(`/api/configs/project-name`)
          .then((res) => {
            commit("setProjectName", res.data);
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    getQualityPercent: async function ({}) {
      return await new Promise((resolve, reject) => {
        Vue.axios
          .get(`/api/configs/quality-percent`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    getReadGrades: async function () {
      let res = await Vue.axios.get(`/api/enums/read-grades`);
      return res.data;
    },

    findEntity: async function ({}, url) {
      let res = await Vue.axios.get(url);
      return res.data;
    },

    findEntities: async function ({}, { url = "", params = {} }) {
      let res = await Vue.axios.get(url, {
        params,
        paramsSerializer: (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
      });
      return res.data;
    },

    findAllEntities: async function ({ dispatch }, { url = "", params = {} }) {
      let dataTable,
        page = 0,
        datas = [];
      do {
        dataTable = await dispatch("findEntities", {
          url,
          params: {
            ...params,
            page,
          },
        });
        page++;
        datas.push(...dataTable.content);
      } while (!dataTable.last);
      return datas;
    },

    findCurrentTerm: async function ({}) {
      let res = await Vue.axios.get(`/api/terms/query/current`);
      return res.data;
    },
  },
  modules: {},
  plugins: [vuexLocal.plugin],
});
